import defaultTheme from "tailwindcss/defaultTheme"

export const screens = {
  ...defaultTheme.screens,
  xs: "420px",
  sm: "640px",
  md: "860px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
} as const
